import _ from 'lodash';
import { connect } from 'react-redux';
import { updateUserProfile } from 'app/common/api/common-api';
import Password from 'app/components/settings/password';

const mapStateToProps = state => ({
  userSubmitError: _.get(state, 'common.userSubmitError'),
});

const mapDispatchToProps = dispatch => ({
  onSubmit: values => dispatch(updateUserProfile(values)),
});

const PasswordContainer = connect(mapStateToProps, mapDispatchToProps)(Password);

export default PasswordContainer;



// WEBPACK FOOTER //
// ./app/containers/settings/password.js